module.exports = __webpack_public_path__ + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-10.2ff4cff3.png";


//////////////////
// WEBPACK FOOTER
// ./components/UpgradeConfirmationView/images/radiance/radiance-10.png
// module id = 2684
// module chunks = 11